export default __webpack_public_path__ + "static/media/payment-terminals-primary.347e8b0f.svg";